import { create } from "zustand";

const useAnimationStore = create((set) => ({
  isStart: false, // Trạng thái hiệu ứng
  scale: { scaleX: 1, scaleY: 1 }, // Lưu tỷ lệ scale
  isShowResult: false,
  isLoading: false,
  isReplaying: false,
  showResult: () => set({isShowResult: true}),
  // Hàm để dừng hiệu ứng
  startEffect: () => set({ isStart: true }),

  // Hàm để tiếp tục hiệu ứng
  resumeEffect: () => set({ isStart: false }),

  // Hàm tính toán tỷ lệ scale cho SVG
  calculateScale: (svgElement, screenWidth, screenHeight) => {
    if (!svgElement) return; // Kiểm tra nếu không có phần tử SVG

    // Lấy thuộc tính viewBox
    const viewBox = svgElement.getAttribute("viewBox");
    if (!viewBox) return;

    const [x, y, viewBoxWidth, viewBoxHeight] = viewBox.split(" ").map(Number);

    // Tính tỷ lệ scale
    const scaleX = screenWidth / viewBoxWidth;
    const scaleY = screenHeight / viewBoxHeight;

    set({ scale: { scaleX, scaleY } });
  },

  replay: () => set({
    isReplaying: true,
    isShowResult: false
  }),

  restart: () => set({
    isReplaying: false
  })

}));

export default useAnimationStore;
